import Network from 'infrastructure/js/modules/network';
import * as stationsService from '../../../services/Stations/stationsService';
import { api as spoolingGrigApi } from '../SpoolingView/spoolingGridActions.js';
import {api as locationPageApi} from '../locationPageActions';

/////////////////////////////////////////
// ACTION TYPES - PUBLIC, FOR REDUCERS
export const actionTypes = {
  LOCATIONPAGE_SPOOLING_VIEW_FETCHCHARTS_FINISHED: 'LOCATIONPAGE_SPOOLING_VIEW_FETCHCHARTS_FINISHED'

};


////////////////////////////////////////////////////////////////
// PLAIN ACTION CREATORS - PRIVATE, FOR LOCAL DISPATCH ONLY
const actions = {
  fetchChartsFinished: function(payload) {
    return {type: actionTypes.LOCATIONPAGE_SPOOLING_VIEW_FETCHCHARTS_FINISHED, payload: payload };
  },
};

/////////////////////////////////////////////////////
// METHODS FOR JSX PROPS - PUBLIC, ALL THUNK TYPE
export let jsxActions = {};


jsxActions.clearFilters = function () {
  return function (dispatch, getState) {
    spoolingGrigApi.clearFilters(dispatch, getState)();
  }
};

/////////////////////////////////////////////////////////////////////////
// API METHODS - PUBLIC, FOR OTHER ACTION MODULES (and internal use)
export let api = {};

api.init = function(dispatch, getState) {
  return function(shouldRefreshGrid) {
    if (shouldRefreshGrid) {
      spoolingGrigApi.reload(dispatch, getState)();
    }
    return api.fetchCharts(dispatch, getState)();
  };
};

api.fetchCharts = function(dispatch, getState) {
  return function() {

    let locationId = locationPageApi.getLocationId(dispatch, getState)();
    return stationsService.fetchReportedSpools(locationId)
      .then((response) => {
        if (!Network.isResponseValid(response)) {
          console.error('fetchCharts(): Fetching reported spools failed', response);
          return {success: false};
        }

        dispatch(actions.fetchChartsFinished({reportedSpoolsCount: response.data?.data ?? 0}));
      });
  }
};



